export const pageSizes = [
  { label: "10", value: 10 },
  { label: "20", value: 20 },
  { label: "40", value: 40 }
]
export const defaultPageSize = 10
